(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tv-featured-gallery-nav')) {
    customElements.define(
      'tv-featured-gallery-nav',
      class FeaturedGalleryNavigation extends HTMLElement {
        connectedCallback() {
          this.gallery = this.closest('media-gallery');
          this.buttons = Array.from(this.querySelectorAll('[data-direction]'));
          this.handleClick = this.handleClick.bind(this);
          this.buttons.forEach((button) => button.addEventListener('click', this.handleClick));
        }

        disconnectedCallback() {
          this.buttons?.forEach((button) => button.removeEventListener('click', this.handleClick));
        }

        handleClick(event) {
          if (!this.gallery) return;

          const mediaItems = Array.from(
            this.gallery.querySelectorAll('[id^="Slider-Gallery-"] > [data-media-id]')
          );
          if (mediaItems.length < 2) return;

          const activeIndex = mediaItems.findIndex((item) => item.classList.contains('is-active'));
          const currentIndex = activeIndex < 0 ? 0 : activeIndex;
          const direction = Number.parseInt(event.currentTarget.dataset.direction, 10);
          const nextIndex = (currentIndex + direction + mediaItems.length) % mediaItems.length;
          const targetMedia = mediaItems[nextIndex];

          if (typeof this.gallery.setActiveMedia === 'function') {
            this.gallery.setActiveMedia(targetMedia.dataset.mediaId, false);
            return;
          }

          const targetThumbnail = Array.from(this.gallery.querySelectorAll('[data-target]')).find(
            (thumbnail) => thumbnail.dataset.target === targetMedia.dataset.mediaId
          );
          targetThumbnail?.querySelector('button')?.click();
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-faq"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('tv-faq'))customElements.define('tv-faq',class extends HTMLElement{
  connectedCallback(){
    this.controller?.abort();this.controller=new AbortController();const {signal}=this.controller;
    const input=this.querySelector('input'),select=this.querySelector('select'),items=[...this.querySelectorAll('details')];
    this.querySelector('.tv-faq-tools').hidden=this.dataset.search==='false';
    while(select.options.length>1)select.remove(1);
    [...new Set(items.map(x=>x.dataset.category).filter(Boolean))].forEach(c=>select.add(new Option(c,c)));
    const filter=()=>{let count=0;items.forEach(x=>{x.hidden=!(x.textContent.toLowerCase().includes(input.value.trim().toLowerCase())&&(!select.value||x.dataset.category===select.value));if(!x.hidden)count++;});this.querySelector('[data-empty]').hidden=count!==0;};
    input.addEventListener('input',filter,{signal});select.addEventListener('change',filter,{signal});
    document.addEventListener('shopify:block:select',e=>{const item=e.target.closest('details');if(item&&this.contains(item)){input.value='';select.value='';filter();item.open=true;}},{signal});
  }
  disconnectedCallback(){this.controller?.abort();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-sticky-atc"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tv-sticky-atc')) {
    customElements.define(
      'tv-sticky-atc',
      class StickyAddToCart extends HTMLElement {
        connectedCallback() {
          this.handleViewportChange = this.handleViewportChange.bind(this);
          this.initialize = this.initialize.bind(this);

          if (document.readyState === 'loading') {
            document.addEventListener('DOMContentLoaded', this.initialize, { once: true });
          } else {
            this.initialize();
          }
        }

        disconnectedCallback() {
          document.removeEventListener('DOMContentLoaded', this.initialize);
          window.removeEventListener('scroll', this.handleViewportChange);
          window.removeEventListener('resize', this.handleViewportChange);
          if (this.animationFrame) window.cancelAnimationFrame(this.animationFrame);
        }

        initialize() {
          const shopAnchor = document.querySelector(this.dataset.target);
          this.shopTarget = shopAnchor?.closest('.shopify-section') || shopAnchor;
          window.addEventListener('scroll', this.handleViewportChange, { passive: true });
          window.addEventListener('resize', this.handleViewportChange);
          this.handleViewportChange();
        }

        handleViewportChange() {
          if (this.animationFrame) return;
          this.animationFrame = window.requestAnimationFrame(() => {
            this.animationFrame = null;
            this.updateVisibility();
          });
        }

        isTargetVisible(target) {
          if (!target) return false;
          const rect = target.getBoundingClientRect();
          return rect.bottom > 0 && rect.top < window.innerHeight;
        }

        updateVisibility() {
          const footerTarget = document.querySelector(this.dataset.footerTarget);
          const shopVisible = this.isTargetVisible(this.shopTarget);
          const footerVisible = this.isTargetVisible(footerTarget);
          const shouldShow = Boolean(this.shopTarget) && !shopVisible && !footerVisible;
          this.classList.toggle('is-visible', shouldShow);
          this.toggleAttribute('inert', !shouldShow);
          this.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-story"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tv-mobile-tabs')) {
  customElements.define('tv-mobile-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.controls = this.querySelector('[role="tablist"]');
      this.buttons = [...this.querySelectorAll('[data-mobile-tab]')];
      this.panels = [...this.querySelectorAll('[data-mobile-panel]')];
      if (!this.controls || !this.buttons.length) return;
      this.media = window.matchMedia('(max-width: 749px)');
      this.active = 0;
      this.updateMode();
      this.addEventListener('click', event => {
        const button = event.target.closest('[data-mobile-tab]');
        if (button) this.activate(Number(button.dataset.mobileTab));
      }, { signal });
      this.addEventListener('keydown', event => {
        const button = event.target.closest('[data-mobile-tab]');
        if (!button) return;
        let next = Number(button.dataset.mobileTab);
        if (event.key === 'ArrowRight') next = (next + 1) % this.buttons.length;
        else if (event.key === 'ArrowLeft') next = (next + this.buttons.length - 1) % this.buttons.length;
        else if (event.key === 'Home') next = 0;
        else if (event.key === 'End') next = this.buttons.length - 1;
        else return;
        event.preventDefault();
        this.activate(next);
        this.buttons[next].focus();
      }, { signal });
      this.addEventListener('pointerdown', event => {
        if (!this.media.matches || event.pointerType !== 'touch') return;
        const panel = event.target.closest('[data-mobile-panel]');
        if (!panel || panel.hidden) return;
        this.swipeStart = { x: event.clientX, y: event.clientY, pointerId: event.pointerId };
      }, { signal });
      this.addEventListener('pointerup', event => {
        if (!this.swipeStart || event.pointerId !== this.swipeStart.pointerId) return;
        const dx = event.clientX - this.swipeStart.x;
        const dy = event.clientY - this.swipeStart.y;
        this.swipeStart = null;
        if (Math.abs(dx) < 48 || Math.abs(dx) < Math.abs(dy)) return;
        this.didSwipe = true;
        this.activate((this.active + (dx < 0 ? 1 : -1) + this.buttons.length) % this.buttons.length);
        window.setTimeout(() => { this.didSwipe = false; }, 0);
      }, { signal });
      this.addEventListener('pointercancel', () => { this.swipeStart = null; }, { signal });
      this.addEventListener('click', event => {
        if (!this.didSwipe) return;
        event.preventDefault();
        event.stopPropagation();
        this.didSwipe = false;
      }, { capture: true, signal });
      this.media.addEventListener('change', () => this.updateMode(), { signal });
      document.addEventListener('shopify:block:select', event => {
        const panel = event.target.closest('[data-mobile-panel]');
        if (panel && this.contains(panel)) this.activate(Number(panel.dataset.mobilePanel));
      }, { signal });
    }
    updateMode() {
      const mobile = this.media.matches;
      this.controls.hidden = !mobile;
      this.panels.forEach((panel, index) => {
        panel.hidden = mobile && index !== this.active;
        if (mobile) {
          panel.setAttribute('role', 'tabpanel');
          panel.setAttribute('aria-labelledby', this.buttons[index].id);
          panel.tabIndex = 0;
        } else {
          panel.removeAttribute('role');
          panel.removeAttribute('aria-labelledby');
          panel.removeAttribute('tabindex');
        }
      });
    }
    activate(index) {
      this.active = index;
      this.buttons.forEach((button, buttonIndex) => {
        button.setAttribute('aria-selected', String(buttonIndex === index));
        button.tabIndex = buttonIndex === index ? 0 : -1;
      });
      this.updateMode();
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tv-tabs"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('tv-tabs')) {
  customElements.define('tv-tabs', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      this.buttons = [...this.querySelectorAll('[data-tab]')];
      this.panels = [...this.querySelectorAll('[data-panel]')];
      if (!this.buttons.length) return;
      this.querySelector('[role="tablist"]').hidden = false;
      this.panels.forEach((p,i) => {p.setAttribute('role','tabpanel');p.setAttribute('aria-labelledby',this.buttons[i].id);p.tabIndex=0;});
      this.activate(0);
      this.addEventListener('click', e => { const b = e.target.closest('[data-tab]'); if(b) this.activate(Number(b.dataset.tab)); }, { signal });
      this.addEventListener('keydown', e => {
        const b=e.target.closest('[data-tab]');if(!b)return;
        let n=Number(b.dataset.tab);
        if(e.key==='ArrowRight')n=(n+1)%this.buttons.length;
        else if(e.key==='ArrowLeft')n=(n+this.buttons.length-1)%this.buttons.length;
        else if(e.key==='Home')n=0;
        else if(e.key==='End')n=this.buttons.length-1;
        else return;
        e.preventDefault();this.activate(n);this.buttons[n].focus();
      }, { signal });
      document.addEventListener('shopify:block:select', e => {
        const panel=e.target.closest('[data-panel]');if(panel&&this.contains(panel))this.activate(Number(panel.dataset.panel));
      }, { signal });
    }
    activate(n) { this.buttons.forEach((b,i)=>{b.setAttribute('aria-selected',String(i===n));b.tabIndex=i===n?0:-1;});this.panels.forEach((p,i)=>p.hidden=i!==n); }
    disconnectedCallback() { this.controller?.abort(); }
  });
}

  } catch(e) { console.error(e); }
})();
})();
